<div class="navigation">
  <div class="d-flex mb-3">
    <a [routerLink]="[homeRoute]">
      <img class="logo" src="/assets/img/logo.svg">
    </a>
  </div>
  <div class="d-flex mb-3">
    <app-language-selector></app-language-selector>
    @if (authService.isUserLoggedIn()){
      <button class="user-btn" ejs-dropdownbutton
              [items]="userNavigation"
              [content]="authService.getUserInfo() ? '\<span class=\'user-name\'>' + authService.getUserInfo().userName + '\</span>': ''"
              [iconCss]="userIcon"
              (select)="onSelection($event)">
      </button>
    }
  </div>

  @if (authService.isUserLoggedIn()){
    <ejs-accordion (created)="onAccordionCreated()">
      <e-accordionitems>
        <e-accordionitem>
          <ng-template #header>
            <a [routerLinkActive]="['active']" [routerLink]="[homeRoute]">{{ 'i18n.core.navigation.home' | translate }}</a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{adminSectionId}}" [visible]="authService.isUserAdminOrConfigurationAdminOrAssetAdmin()">
          <ng-template #header>
            <div>{{ 'i18n.core.navigation.administration' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[clientAdministrationRoute]" [hidden]="!authService.isUserAdmin()">
              {{ 'i18n.core.navigation.companies' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[userAdministrationRoute]">
              {{ 'i18n.core.navigation.users' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{exportConfigurationSectionId}}" [visible]="authService.canUserAccessExportConfiguration()">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.export-configuration' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[configurationsExpConfRoute]">
              {{ 'i18n.core.navigation.configurations' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[fieldValueReplacementsRoute]" [hidden]="!authService.isUserAdminOrConfigurationAdmin()">
              {{ 'i18n.core.navigation.fieldValueReplacements' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[configurationTemplatesExpConfRoute]" [hidden]="!authService.isUserAdminOrConfigurationAdmin()">
              {{ 'i18n.core.navigation.configurationTemplates' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[fieldAssignmentTemplatesExpConfRoute]" [hidden]="!authService.isUserAdminOrConfigurationAdmin()">
              {{ 'i18n.core.navigation.fieldAssignmentTemplates' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[emailTemplatesExpConfRoute]" [hidden]="!authService.isUserAdminOrConfigurationAdmin()">
              {{ 'i18n.core.navigation.emailTemplates' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[activationEmailTemplatesExpConfRoute]" [hidden]="!authService.isUserAdminOrConfigurationAdmin()">
              {{ 'i18n.core.navigation.activationEmailTemplates' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[historyExpConfRoute]" [hidden]="!authService.canUserAccessExportHistory()">
              {{ 'i18n.core.navigation.history' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{manualImportSectionId}}" [visible]="authService.canUserAccessImportInterface()">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.manual-import' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[manualImportSalesOrdersRoute]">
              {{ 'i18n.core.navigation.SalesOrder' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[manualImportVendorDeliveryDateRoute]">
              {{ 'i18n.core.navigation.VendorDeliveryDate' | translate }}
            </a>
            <!-- <a [routerLinkActive]="['active']" [routerLink]="[manualImportSerialNumbersRoute]">
              {{ 'i18n.core.navigation.SerialNumber' | translate }}
            </a> -->
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{importConfigurationSectionId}}" [visible]="authService.canUserAccessImportInterface()">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.import-configuration' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[importConfigurationConfigurationRoute]">
              {{ 'i18n.core.navigation.configurations' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[importConfigurationProtocolRoute]">
              {{ 'i18n.core.navigation.import-configuration-protocol' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[importConfigurationTemplateRoute]">
              {{ 'i18n.core.navigation.configurationTemplates' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[importConfigurationGlobalRoute]" [hidden]="!authService.isUserAdmin()">
              {{ 'i18n.core.navigation.globalConfigurations' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[acodisWorkflowRoute]" [hidden]="!authService.isUserAdmin()">
              {{ 'i18n.core.navigation.acodis-workflow' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{assetsSectionId}}" [visible]="authService.canUserAccessAnyAssets()">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.assets' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[productAssetsRoute]" [hidden]="!authService.canUserAccessProductAssets()">
              {{ 'i18n.core.navigation.product-assets' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[brandLogosRoute]" [hidden]="!authService.canUserAccessBrandLogos()">
              {{ 'i18n.core.navigation.brand-logos' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[assetsStorageRoute]" [hidden]="!authService.canUserAccessAssetStorage()">
              {{ 'i18n.core.navigation.asset-storage' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[assetCollectionsRoute]" [hidden]="!authService.canUserAccessAssetCollections()">
              {{ 'i18n.core.navigation.asset-collections' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[assetsStorageSettingsRoute]" [hidden]="!authService.canUserAccessAssetStorageSettings()">
              {{ 'i18n.core.navigation.asset-storage-settings' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{vendorScoreCardSectionId}}" [visible]="authService.hasUserVendorScoreCardAdminRole() && activateVendorScoreCardFeature">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.vendor-score-card' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[vendorScoreCardVendorsRoute]" [hidden]="!authService.hasUserVendorScoreCardAdminRole()">
              {{ 'i18n.core.navigation.vendor-score-card-vendors' | translate }}
            </a>
            <a [routerLinkActive]="['active']" [routerLink]="[vendorScoreCardAdministrationRoute]" [hidden]="!authService.hasUserVendorScoreCardAdminRole()">
              {{ 'i18n.core.navigation.vendor-score-card-administration' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
        <e-accordionitem id="{{settingsSectionId}}" [visible]="authService.isUserAdmin()">
          <ng-template #header>
            <div >{{ 'i18n.core.navigation.settings' | translate }}</div>
          </ng-template>
          <ng-template #content>
            <a [routerLinkActive]="['active']" [routerLink]="[emailSettingsRoute]">
              {{ 'i18n.core.navigation.email-settings' | translate }}
            </a>
          </ng-template>
        </e-accordionitem>
      </e-accordionitems>
    </ejs-accordion>
  }
</div>
